import { generateColumnId } from '../../../utils';
import * as FIELDS from '../../fields';
import { REPORT_PRESET } from '../../pickers';
import { CAMPAIGNS_GROUPS_REALTIME_REPORT_ID } from './campaignGroupRealtimeReportId';

const customColumns = {
    [REPORT_PRESET.PERFORMANCE]: [
        FIELDS.SPENT.field,
        FIELDS.VISIBLE_IMPRESSIONS.field,
        FIELDS.IMPRESSIONS.field,
        FIELDS.CLICKS.field,
        FIELDS.CONVERSIONS.field,
        FIELDS.CPA.field,
        FIELDS.CVR.field,
        FIELDS.AVERAGE_CPC.field,
        FIELDS.VCTR.field,
        FIELDS.VCPM.field,
        FIELDS.CONVERSIONS_VALUE.field,
        FIELDS.ROAS.field,
        FIELDS.UNIQUE_IMPRESSIONS.field,
        FIELDS.UNIQUE_VIEWABLE_IMPRESSIONS.field,
        FIELDS.UNIQUE_CLICKS.field,
    ].map(field => generateColumnId(CAMPAIGNS_GROUPS_REALTIME_REPORT_ID, field)),
    [REPORT_PRESET.SETUP]: [
        FIELDS.CAMPAIGNS_GROUP_STATUS.field,
        FIELDS.CAMPAIGNS_GROUP_ID.field,
        FIELDS.ACCOUNT_ID.field,
        FIELDS.ACCOUNT_DESCRIPTION.field,
        FIELDS.CAMPAIGNS_GROUP_BUDGET.field,
        FIELDS.CAMPAIGNS_GROUP_REMAINING_BUDGET.field,
        FIELDS.BID.field,
        FIELDS.CPA_GOAL.field,
        FIELDS.BID_STRATEGY.field,
        FIELDS.SAFETY_LEVEL.field,
        FIELDS.START_DATE.field,
        FIELDS.END_DATE.field,
    ].map(field => generateColumnId(CAMPAIGNS_GROUPS_REALTIME_REPORT_ID, field)),
};

const defaultColumns = [
    FIELDS.IS_SELECTED.field,
    FIELDS.IS_ACTIVE.field,
    FIELDS.CAMPAIGNS_GROUP_STATUS.field,
    FIELDS.CAMPAIGNS_GROUP_NAME.field,
    FIELDS.CAMPAIGNS_GROUP_ID.field,
    FIELDS.CAMPAIGNS_GROUP_LINKED_CAMPAIGNS.field,
    FIELDS.CAMPAIGNS_GROUP_BUDGET.field,
    FIELDS.CAMPAIGNS_GROUP_REMAINING_BUDGET.field,
    FIELDS.SPENT.field,
    FIELDS.BID_STRATEGY.field,
    FIELDS.BID.field,
    FIELDS.CPA_GOAL.field,
    FIELDS.VISIBLE_IMPRESSIONS.field,
    FIELDS.CLICKS.field,
    FIELDS.CONVERSIONS.field,
    FIELDS.CPA.field,
    FIELDS.CVR.field,
    FIELDS.AVERAGE_CPC.field,
    FIELDS.VCTR.field,
    FIELDS.VCPM.field,
    FIELDS.SAFETY_LEVEL.field,
    FIELDS.START_DATE.field,
    FIELDS.END_DATE.field,
    FIELDS.ACTIONS_COLUMN.field,
    FIELDS.ACTIONS_COLUMN.field,
].map(field => generateColumnId(CAMPAIGNS_GROUPS_REALTIME_REPORT_ID, field));

const performanceColumns = [
    FIELDS.IS_SELECTED.field,
    FIELDS.IS_ACTIVE.field,
    FIELDS.CAMPAIGNS_GROUP_NAME.field,
    FIELDS.ID.field,
    FIELDS.SPENT.field,
    FIELDS.VISIBLE_IMPRESSIONS.field,
    FIELDS.CLICKS.field,
    FIELDS.CONVERSIONS.field,
    FIELDS.CPA.field,
    FIELDS.CVR.field,
    FIELDS.AVERAGE_CPC.field,
    FIELDS.VCTR.field,
    FIELDS.VCPM.field,
    FIELDS.CONVERSIONS_VALUE.field,
    FIELDS.ROAS.field,
    FIELDS.ACTIONS_COLUMN.field,
].map(field => generateColumnId(CAMPAIGNS_GROUPS_REALTIME_REPORT_ID, field));

const setupColumns = [
    FIELDS.IS_SELECTED.field,
    FIELDS.IS_ACTIVE.field,
    FIELDS.CAMPAIGNS_GROUP_ID.field,
    FIELDS.ACCOUNT_ID.field,
    FIELDS.ACCOUNT_DESCRIPTION.field,
    FIELDS.CAMPAIGNS_GROUP_NAME.field,
    FIELDS.CAMPAIGNS_GROUP_STATUS.field,
    FIELDS.CAMPAIGNS_GROUP_BUDGET.field,
    FIELDS.SPENT.field,
    FIELDS.CPA_GOAL.field,
    FIELDS.START_DATE.field,
    FIELDS.END_DATE.field,
    FIELDS.ACTIONS_COLUMN.field,
].map(field => generateColumnId(CAMPAIGNS_GROUPS_REALTIME_REPORT_ID, field));

export { customColumns, defaultColumns, performanceColumns, setupColumns };
